import React from 'react';
import './TermsAndConditions.css';
import { Helmet } from 'react-helmet';

const PrivacyPolicy = () => { 

  return (
    <>

    <Helmet>
    <title>Privacy Policy | SkillzVerse</title>

    <meta
        name="description"
        content="Read the SkillzVerse Privacy Policy to understand how we collect, use, protect, and manage your personal information, cookies, and data while using our platform."
    />

    <meta
        name="keywords"
        content="Privacy Policy,Data Privacy Policy,Data Protection Policy,Personal Information Policy,User Privacy,Privacy Statement"
    />

    <link
        rel="canonical"
        href="https://skillzverse.com/privacy-policy"
    />
</Helmet>
    <div className="privacy-policy-container">
      <h1>SkillzVerse Privacy Policy</h1>
      {/* <p><strong>Effective Date:</strong> 1st Jan 2025</p> */}

      <section className="privacy-section">
        <h2>1. Information We Collect</h2>
        <p>
          We collect personal information when you register, make purchases, or interact with our platform. This includes your name, email address, payment details, and usage data.
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. How We Use Your Information</h2>
        <p>
          We use the data to process payments, provide customer support, and personalize your experience. We may also use your information for marketing purposes, but only with your consent.
        </p>
      </section>

      <section className="privacy-section">
        <h2>3. Data Storage & Security</h2>
        <p>
          We store your data securely, taking steps to protect it. While no system is completely secure, we make every effort to prevent unauthorized access or disclosure of your information.
        </p>
      </section>

      <section className="privacy-section">
        <h2>4. User Rights</h2>
        <p>
          You have the right to access, update, and delete your data. You can also opt-out of marketing communications at any time.
        </p>
      </section>
 

      <section className="privacy-section">
        <h2>5. Changes to This Privacy Policy</h2>
        <p>
          We may update our Privacy Policy periodically. Changes will be communicated through the platform.
        </p>
      </section>

      <section  className="terms-section">
        <h2>6. Contact Us</h2>
        <p>If you have any questions, please <a href="/support" className="contact-link">reach out to us on our contact page</a>.</p>
      </section>
    </div>
    </>
  );
};

export default PrivacyPolicy;
